import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import InnerImageZoom from 'react-inner-image-zoom'
import Slider from "react-slick"
import PDFV from './PdfView'
import ver from "../img/ver.png";

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: "absolute",
        backgroundColor: "#151515",
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: "12px",
        width: "fit-content",
        maxHeight: "94vh",
        maxWidth: "94vw",
        outline: "none",
    },
}));
const site = "https://api.guasasapo.cl";

export default function SimpleModal(props) {
    const imagencc = Array.isArray(props.imagen) ? props.imagen : [];
    const hasPdf = Boolean(props.pdf);
    const hasImages = imagencc.length > 0;
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(false);
    const [slideIndex, setSlideIndex] = React.useState(0);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleClickAway = () => setOpen(false);

    const settings = {
        dots: true,
        infinite: true,
        speed: 350,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        fade: false,
        beforeChange: (_, next) => setSlideIndex(next),
    };

    if (!hasPdf && !hasImages) return null;

    const currentImage = hasImages ? imagencc[slideIndex] : null;
    const currentDownload = currentImage ? `${site}${currentImage.url}` : null;

    return (
        <div>
            <div className="ctnportada" onClick={handleOpen}>
                <img src={ver} alt="ver"></img>
                <p>VER</p>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div style={modalStyle} className={classes.paper}>
                        <p onClick={handleClose} className="xmodal">x</p>
                        <ClickAwayListener onClickAway={handleClickAway}>
                            <div>
                                {hasPdf ? (
                                    <PDFV pdf={props.pdf} />
                                ) : (
                                    <div className="imgsliderc" style={{ width: 'min(88vw, 1400px)', position: 'relative' }}>
                                        {currentDownload ? (
                                            <a
                                                href={currentDownload}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                aria-label="Descargar imagen"
                                                style={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '10px',
                                                    width: '78px',
                                                    height: '78px',
                                                    background: '#000',
                                                    zIndex: 20,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    textDecoration: 'none',
                                                    boxShadow: '0 0 0 2px #000'
                                                }}
                                            >
                                                <div style={{ color: '#fff', fontSize: '9px', letterSpacing: '0.06em', textAlign: 'center', lineHeight: 1.15 }}>
                                                    ⬇<br />DESCARGAR
                                                </div>
                                            </a>
                                        ) : null}
                                        <Slider {...settings} style={{ paddingLeft: 0 }}>
                                            {imagencc.map((i) => {
                                                const isVertical = (i.height || 0) > (i.width || 0);
                                                return (
                                                    <div className="imageContainer" key={i.url}>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                height: 'min(84vh, 1100px)',
                                                                width: '100%',
                                                            }}
                                                        >
                                                            <div style={{ width: isVertical ? 'min(56vw, 760px)' : 'min(84vw, 1320px)' }}>
                                                                <InnerImageZoom
                                                                    zoomScale={0.8}
                                                                    src={site + i.url}
                                                                    alt={i.name}
                                                                    style={{ width: '100%', maxHeight: '84vh', objectFit: 'contain' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </Slider>
                                    </div>
                                )}
                            </div>
                        </ClickAwayListener>
                    </div>
                </Modal>
            </div>
        </div>
    );
}
